import request from '../index'



//类型列表
export function getHomeData() {
  return request({
    url: '/web/question/listType',
    method: 'get'
  })
}
// 题库列表
export function getQuestionList(data) {
  return request({
    url: '/web/question/listQuestion',
    method: 'post',
    data
  })
}